const AddServiceAccount = function () {
    var Message;
    var Counter;

    function GetList() {
        Message = document.getElementById("message");
        var url = document.getElementById("urlIdentity").value;
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        var params = "login=" + document.getElementById("login").value + "&password=" + document.getElementById("password").value;
        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) {
                Message.innerHTML = "<h3 style='color: green'>Поиск сервисной карты...</h3>";
                return;
            }
            if (xhr.status >= 200 && xhr.status < 300) {
                var CardId = xhr.responseText;
                if (CardId == "0")
                    Message.innerHTML = "<h3 style='color: red'>Сервисная карта с такими учётными данными не обнаружена.</h3>";
                else
                    GetAccounts(CardId);
            }
            else
                Message.innerHTML = "<h3 style='color: red'>Ошибка: " + xhr.status + ' ' + xhr.statusText + "</h3>";
        };
        xhr.send(params);
        return true;
    }

    function GetAccounts(CardId) {
        document.getElementById("serviceCardId").value = CardId;
        var url = document.getElementById("urlAccounts").value.replace("=U=", CardId);
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'json';
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) {
                Message.innerHTML = "<h3 style='color: green'>Ожидайте загрузки данных...</h3>";
                return;
            }
            if (xhr.status >= 200 && xhr.status < 300)
                PrintReport(xhr.response.Data);
            else
                Message.innerHTML = "<h3 style='color: red'>Ошибка: " + xhr.status + ' ' + xhr.statusText + "</h3>";
        };
        xhr.send();
        return true;
    }

    // Вывод счетов.
    function PrintReport(result) {
        var Report = document.getElementById("report");
        Report.innerHTML = "";
        var BlockAccount = document.getElementById("BlockAccount").innerHTML;
        Counter = 0;
        if (result.length > 0) {
            for (var i = 0; i < result.length; i++) {
                if (document.getElementById("userAccounts").value.indexOf(result[i].AccountId) == -1) {
                    var color = "#000000";
                    if (result[i].LegalAccountStatus == "Opened") color = "#0078A8";
                    if (result[i].LegalAccountStatus == "Closed") color = "#EF4056";
                    Report.innerHTML += BlockAccount.replace("=Name=", result[i].ContragentShortName)
                        .replace(/=i=/g, String(Counter++))
                        .replace("=accId=", result[i].AccountId)
                        .replace("=num=", result[i].ContractNumber)
                        .replace("=dat=", moment(result[i].ContractDate).format("DD.MM.YYYY"))
                        .replace("=ent=", result[i].Division.Caption)
                        .replace("=accId=", result[i].AccountId)
                        .replace("=INN=", result[i].AccountNumber)
                        .replace("=Status=", result[i].LegalAccountStatus)
                        .replace("Opened", "Активен")
                        .replace("Closed", "Закрыт")
                        .replace(/null/g, "")
                        .replace("Invalid date", "")
                        .replace(/#000000/g, color);
                }
            }
        }
        if (Counter > 0) {
            document.getElementById("ListAccounts").style.display = "block";
            Message.innerHTML = "";
        }
        else
            Message.innerHTML = "<h3 style='color: green'>Нет счетов для подключения.</h3>";
        return true;
    }

    function PostAccounts() {
        var cnt = 0;
        for (var i = 0; i < Counter; i++) {
            if (document.getElementById("CheckBox" + String(i)).checked) {
                document.getElementById("Hidden" + String(i)).name = "accountId";
                cnt++;
            }
        }
        if (cnt > 0)
            document.getElementById("ReportForm").submit();
        else
            Message.innerHTML = "<h3 style='color: red'>Выберите счёт.</h3>"
    }

    function CheckAll(all) {
        for (var i = 0; i < Counter; i++) {
            document.getElementById("CheckBox" + String(i)).checked = all.checked;
        }
    }

    function UnCheckAll() {
        var ch = true;
        for (var i = 0; i < Counter; i++) {
            ch &= document.getElementById("CheckBox" + String(i)).checked;
        }
        document.getElementById("CheckAll").checked = ch;
    }

    return {
        GetList: GetList,
        CheckAll: CheckAll,
        PostAccounts: PostAccounts,
        UnCheckAll: UnCheckAll
    };
}();
export {
    AddServiceAccount
};



// WEBPACK FOOTER //
// ./wwwroot/app/UL/AddServiceAccount.js